import { render, staticRenderFns } from "./groupManage.vue?vue&type=template&id=38f0b380&scoped=true"
import script from "./groupManage.vue?vue&type=script&lang=js"
export * from "./groupManage.vue?vue&type=script&lang=js"
import style0 from "./groupManage.vue?vue&type=style&index=0&id=38f0b380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0b380",
  null
  
)

export default component.exports